module.exports = __webpack_public_path__ + "static/media/search_icon.ed31f3dc.svg";